import { AppModule } from 'app/module';
import { EbRecruiterItem } from 'module/ebRecruiterItem/main';
import { CompanyRecruiterInquiryModal } from 'module/companyRecruiterInquiryModal/main';
import Template from './template.hbs';
import './styles.scss';

export class EbContactPerson extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            toggleShowMore: '.m-ebContactPerson__showMore',
            companyRecruiterInquiryModal: '.m-companyRecruiterInquiryModal',
            leftBoxTitle: '.m-ebContactPerson__leftBoxTitle',
            recruiters: ['.m-ebRecruiterItem'],
        };
    }

    getPropsFromDom() {
        return {
            hasMore: !!this.dom.toggleShowMore,
            showMore: false,
        };
    }

    subs() {
        if (this.dom.recruiters) {
            this.recruiters = [];
            const recruiterItemProps = [];
            for (let i = 0; i < this.dom.recruiters.length; i += 1) {
                this.recruiters[i] = new EbRecruiterItem(this.dom.recruiters[i]);
                recruiterItemProps[i] = this.recruiters[i].getPropsFromDom();
            }
            this.props.recruiters = recruiterItemProps;
        }

        if (this.dom.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal = new CompanyRecruiterInquiryModal(this.dom.companyRecruiterInquiryModal);
        }
    }

    domEvents() {
        if (this.dom.toggleShowMore) {
            this.dom.toggleShowMore.addEventListener('click', (e) => this.toggleRecruiters(e));
        }
    }

    toggleRecruiters(e) {
        if (e) e.preventDefault();
        if (this.props.showMore) {
            this.events.emit('scrollToSection');
        }
        this.updateProps({ showMore: !this.props.showMore }, true);
    }

    subEvents() {
        if (this.recruiters) {
            for (let i = 0; i < this.recruiters.length; i += 1) {
                this.recruiters[i].events.on('openInquiryModal', (context) => {
                    const [firstArgument] = context.arguments;
                    this.companyRecruiterInquiryModal.props = firstArgument;
                    this.companyRecruiterInquiryModal.updateProps(
                        Object.assign(
                            this.companyRecruiterInquiryModal.getPropsFromDom(),
                            { visible: true, active: true },
                        ),
                        true,
                    );
                    this.companyRecruiterInquiryModal.loadCaptcha();
                    this.events.emit('addModalStyle');
                });

                this.recruiters[i].events.on('updateRecruiterItemProps', () => {
                    this.props.recruiters[i] = this.recruiters[i].getPropsFromDom();
                });
                this.propagateEvents(this.recruiters[i], 'updateIFrame');
            }
        }

        if (this.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal.events.on('showCompanyRecruiterInquiryToast', () => {
                this.events.emit('showCompanyRecruiterInquiryToast');
            });

            this.companyRecruiterInquiryModal.events.on('removeModalStyle', () => {
                this.events.emit('removeModalStyle');
            });

            this.companyRecruiterInquiryModal.events.on('addModalStyle', () => {
                this.events.emit('addModalStyle');
            });
        }
    }

    loadCaptcha() {
        if (this.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal.loadCaptcha();
        }
    }
}
